var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentimentNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.867 62.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.neutral-fill{fill:#FF8800;}\n\t\t"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "neutral-fill",
    d: "M31.434,0A31.434,31.434,0,1,0,62.867,31.434,31.47,31.47,0,0,0,31.434,0Zm0,60.134a28.7,28.7,0,1,1,28.7-28.7A28.732,28.732,0,0,1,31.434,60.134Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "neutral-fill",
    d: "M100.1,136.2a4.1,4.1,0,1,0-4.1-4.1A4.105,4.105,0,0,0,100.1,136.2Zm0-5.467a1.367,1.367,0,1,1-1.367,1.367A1.369,1.369,0,0,1,100.1,130.733Z",
    transform: "translate(-79.6 -106.133)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "neutral-fill",
    d: "M228.1,128a4.1,4.1,0,1,0,4.1,4.1A4.105,4.105,0,0,0,228.1,128Zm0,5.467a1.367,1.367,0,1,1,1.367-1.367A1.369,1.369,0,0,1,228.1,133.467Z",
    transform: "translate(-185.733 -106.133)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "neutral-fill",
    d: "M124.7,224H97.367a1.367,1.367,0,1,0,0,2.733H124.7a1.367,1.367,0,0,0,0-2.733Z",
    transform: "translate(-79.6 -185.733)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentNeutral);
export default __webpack_public_path__ + "static/media/sentiment-neutral.b8067a69.svg";
export { ForwardRef as ReactComponent };